import {
  AI_CONFIGURATION_PREPEND,
  CONFIGURATION_PREPEND,
  CONFIGURATION_ROUTER_URL,
  FACULTY_PREPEND,
  FACULTY_ROUTER_URL,
  FRESHMAN_ROUTER_URL,
  ROUTER_URL,
  STAFF_PREPEND,
  STAFF_ROUTER_URL,
  STUDENT_PREPEND,
  STUDENT_ROUTER_URL,
} from "../../constants/routerUrl";
import { connect } from "react-redux";
import { logoutUser } from "../../action/common/keyClaokActionCreator";
import { NavLink, useLocation } from "react-router-dom";
import { UserTypes } from "../../models/dashboard/adminDashboard";

const AdminMenu = (props: any) => {
  const location = useLocation();
  const isActive = (path: string) => location.pathname.startsWith(path);

  const { user } = props;

  return (
    <>
      <ul className="accordion-menu">
        <li>
          <NavLink
            to={ROUTER_URL.COLLEGE_INDEX}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            University Management
          </NavLink>
        </li>
        <li>
          <NavLink
            to={ROUTER_URL.DEPARTMENT_INDEX}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            Department
          </NavLink>
        </li>
        <li>
          <NavLink
            to={CONFIGURATION_ROUTER_URL.BUTTON_INDEX}
            className={
              isActive(CONFIGURATION_PREPEND)
                ? "menu-title active"
                : "menu-title"
            }
          >
            Configuration
          </NavLink>
        </li>
        <li>
          <NavLink
            to={ROUTER_URL.AI_CONFIGURATION}
            className={
              isActive(AI_CONFIGURATION_PREPEND)
                ? "menu-title active"
                : "menu-title"
            }
          >
            AI Configuration
          </NavLink>
        </li>
        <li>
          <NavLink
            to={STAFF_ROUTER_URL.BUTTON_PRIORITY}
            state={{ userRole: UserTypes.Staff }}
            className={
              isActive(STAFF_PREPEND) ? "menu-title active" : "menu-title"
            }
          >
            Staff
          </NavLink>
        </li>
        <li>
          <NavLink
            to={STUDENT_ROUTER_URL.BUTTON_PRIORITY}
            state={{ userRole: UserTypes.Student }}
            className={
              isActive(STUDENT_PREPEND) ? "menu-title active" : "menu-title"
            }
          >
            Student
          </NavLink>
        </li>
        <li>
          <NavLink
            to={FACULTY_ROUTER_URL.BUTTON_PRIORITY}
            state={{ userRole: UserTypes.Faculty }}
            className={
              isActive(FACULTY_PREPEND) ? "menu-title active" : "menu-title"
            }
          >
            Faculty
          </NavLink>
        </li>
        <li>
          <NavLink
            to={FRESHMAN_ROUTER_URL.FRESHMAN_CONFIGURATION_INDEX}
            state={{ userRole: UserTypes.Freshman }}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            Freshman
          </NavLink>
        </li>
        <li>
          <NavLink
            to={ROUTER_URL.FEEDBACK}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            Feedback
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.ADMIN_SETTINGS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            Settings
          </NavLink>
        </li>
        <li className="menu-item">
          <NavLink
            to={ROUTER_URL.INSTRUCTIONS}
            className={({ isActive }) =>
              isActive ? "menu-title active" : "menu-title"
            }
          >
            Help
          </NavLink>
        </li>
      </ul>
      <div className="poweredby">
        <a
          href="https://www.buduportal.com/"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img src="/assets/images/budu.png" alt="" />
          Powered by Budu Portal
        </a>
        <p className="version">Version 2.0.0</p>
        <p className="copyrights">
          &copy; 2025 Budu Portal. All rights reserved.
        </p>
      </div>
    </>
  );
};
const mapDispatchToProps = {
  logout: () => logoutUser(),
};

function mapStateToProps(state: any) {
  return {
    currentRole: state.userDetails.userProfileData?.currentRole,
    user: state.userDetails.userProfileData,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AdminMenu);
